export default __webpack_public_path__ + "static/media/young-brunette-man-showing-fingers-up.90a1a869.webp";